import React from "react";
import { useGetSoulmatesQuery } from '../../apis';
import { Spinner, SpinnerVariants } from "../../UI";
import { SoulmateCard } from "./SoulmateCard/SoulmateCard";

export const Soulmates: React.FC = () => {
  const { data, isLoading, error } = useGetSoulmatesQuery({ limit: 10 });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Spinner variant={SpinnerVariants.SMALL_CIRCLE} />
      </div>
    );
  }

  if (error) {
    const errorMessage = 'message' in error ? error.message : 'Failed to load soulmates';
    return (
      <div className="flex flex-col items-center justify-center min-h-screen p-8">
        <div className="text-red-500 text-lg mb-4">
          {errorMessage}
        </div>
        <p className="text-app-gray-light">
          Please try again later or answer more questions to find compatible users.
        </p>
      </div>
    );
  }

  const soulmates = data?.soulmates ?? [];

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-white mb-2">
          Your Soulmates
        </h1>
        <p className="text-app-gray-light">
          Users whose opinions align most closely with yours
        </p>
      </div>

      {soulmates.length === 0 ? (
        <div className="text-center py-12">
          <div className="text-6xl mb-4">💕</div>
          <h2 className="text-xl font-semibold text-white mb-2">
            No soulmates found yet
          </h2>
          <p className="text-app-gray-light max-w-md mx-auto">
            Answer more questions to find users who share your views! 
            You need to have answered at least 10 questions in common with other users.
          </p>
        </div>
      ) : (
        <>
          <div className="text-center mb-6">
            <p className="text-sm text-app-gray">
              Found {soulmates.length} compatible user{soulmates.length !== 1 ? 's' : ''}
            </p>
          </div>
          
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {soulmates.map((soulmate) => (
              <SoulmateCard key={soulmate._id} soulmate={soulmate} />
            ))}
          </div>
        </>
      )}
    </div>
  );
};